import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Axios from 'cccisd-axios';
import ClickButton from 'cccisd-click-button';
import Confirm from 'cccisd-confirm';
import notification from 'cccisd-notification';
import IconArrowUp from 'cccisd-icons/arrow-up16';
import Tooltip from 'cccisd-tooltip';

var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;

class PromoteRole extends Component {
    static propTypes = {
        row: PropTypes.object,
        settings: PropTypes.object,
        loadData: PropTypes.func,
    };

    Promote = async () => {
        const { row, loadData } = this.props;

        const pawnId = _get(row, 'pawn.pawnId');
        const pawnHash = _get(row, 'pawn.pawnHash');
        const fullName = _get(row, 'user.fullName');
        const group = Fortress.user.acting.group.label;

        let data = {
            pawnId,
            pawnHash,
        };

        let response = await Axios.post(Boilerplate.route('promote.pawn.role'), data);
        if (response && response.data && response.data.status === 'success') {
            notification({
                message: `${fullName} is now an admin for ${group}.`,
                type: 'success',
                duration: 8000,
            });

            loadData();
        } else {
            notification({
                message: `Error promoting role for ${fullName}.`,
                data: response && response.data && response.data.errors,
                duration: -1,
                type: 'danger',
            });
        }
    };

    confirm = () => {
        const { row } = this.props;

        const fullName = _get(row, 'user.fullName');
        const group = Fortress.user.acting.group.label;

        Confirm({
            message: `Are you sure you want to promote ${fullName}?`,
            description: `You are about to promote user ${fullName} from team member to admin for ${group}.`,
            confirmLabel: 'Promote Role',
            abortLabel: 'Cancel',
        })
            .then(() => {
                this.Promote();
            })
            .fail(() => {
                // close modal
            });
    };

    render() {
        return (
            <Tooltip title="Promote to Admin">
                <ClickButton
                    title={
                        <span>
                            <IconArrowUp />
                        </span>
                    }
                    className="btn btn-xs btn-warning"
                    onClick={this.confirm}
                />
            </Tooltip>
        );
    }
}

export default PromoteRole;
